import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pvd-modal__heading" }
const _hoisted_2 = { id: "fdic-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd_link = _resolveComponent("pvd-link")!
  const _component_pvd_modal = _resolveComponent("pvd-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_pvd_modal, {
      ref: "fdic-modal",
      id: "fdic-modal",
      "pvd-modal-width": "600",
      "pvd-z-index": "9999999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.clientConstants.FDIC_LINK), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.clientConstants.FDIC_INFO) + " ", 1),
          _createVNode(_component_pvd_link, {
            "data-cy": "fdic-gov",
            "pvd-href": _ctx.fdicLink,
            "pvd-new-window": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.FDIC_URL), 1)
            ]),
            _: 1
          }, 8, ["pvd-href"])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}